import {
  getColorButtonAnimation,
  iconButtonAnimation,
} from "@domains/common/utils/animationHelper";
import { Share2Icon } from "@enkor/design/icons";
import { grayScale, pink } from "@enkor/design/colors";
import { GA_EVENT_IDS } from "@domains/common/constants/googleAnalyticsIds";

import * as S from "./HostButtonGroup.style";

interface HostButtonGroupProps {
  onClickShare: () => void;
  onClickChatRoom: () => void;
}

const HostButtonGroup = ({
  onClickShare,
  onClickChatRoom,
}: HostButtonGroupProps) => {
  return (
    <S.SpacedBetweenWrapper>
      <S.ShareButtonBox
        type="button"
        id={GA_EVENT_IDS.EVENT.GUEST_SHARE}
        {...iconButtonAnimation}
        onClick={onClickShare}
      >
        <Share2Icon strokeColor={grayScale.white} />
      </S.ShareButtonBox>
      <S.FullButton
        type="button"
        {...getColorButtonAnimation({
          hoverColor: pink[300],
          tapColor: pink[200],
        })}
        onClick={onClickChatRoom}
      >
        Chat room
      </S.FullButton>
    </S.SpacedBetweenWrapper>
  );
};

export default HostButtonGroup;
